import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './FallbackCard.scss';
import { Button, Spinner, Popover } from '@salesforce/design-system-react';

class FallbackCard extends Component {
  renderImage() {
    const { formatMessage } = this.props.intl;
    const showImage =
      this.props.assetType.fallback && this.props.assetType.fallback_image_link;

    const button = !showImage ? (
      <div className="button-container">
        <Button
          label={formatMessage({
            id: 'components.ecs.fallback.selectAsset'
          })}
          onClick={() => this.props.onSelectFallback(this.props.assetType)}
        />
      </div>
    ) : null;

    const url = this.props.assetType.fallback_image_link;
    const style = { backgroundImage: `url(${url})` };

    const image = showImage ? (
      <Popover
        className="thumbnail-expanded-popover"
        heading={this.props.assetType.fallback_key}
        body={
          <img
            className="thumbnail-cell-popover-img"
            src={url}
            alt={formatMessage(
              {
                id: 'components.ecs.popover.image.altText'
              },
              {
                name: this.props.assetType.fallback_key
              }
            )}
          />
        }
        align="right"
      >
        <Button variant="base" className="img-holder">
          <div className="bg-img" style={style} />
        </Button>
      </Popover>
    ) : null;

    return (
      <div className="card-img">
        {image}
        {button}
        {this.props.isSaving ? (
          <div className="spinner">
            <Spinner variant="brand" />
          </div>
        ) : null}
      </div>
    );
  }

  selectedAsset() {
    const { formatMessage } = this.props.intl;
    if (this.props.assetType.fallback && this.props.assetType.fallback_key) {
      return (
        <div className="selected-asset">
          <div className="label slds-float_left">
            {formatMessage({ id: 'components.ecs.fallback.fallbackAsset' })}
          </div>
          <div className="slds-truncate">
            {this.props.assetType.fallback_key}
          </div>
        </div>
      );
    }
    return (
      <span className="selected-asset">
        {formatMessage({ id: 'components.ecs.fallback.noFallback' })}
      </span>
    );
  }

  replaceButton() {
    const { formatMessage } = this.props.intl;
    if (this.props.assetType.fallback) {
      return (
        <Button
          className="replace-fallback"
          label={formatMessage({
            id: 'components.ecs.fallback.replace'
          })}
          onClick={() => this.props.onSelectFallback(this.props.assetType)}
        />
      );
    }
    return null;
  }

  render() {
    const { formatMessage } = this.props.intl;
    const classNames = this.props.assetType.fallback ? 'card' : 'card empty';
    return (
      <div className={classNames}>
        {this.renderImage()}
        <div className="card-footer">
          <div className="footer-details">
            <div>
              <div className="label slds-float_left">
                {formatMessage({ id: 'components.ecs.fallback.assetClass' })}
              </div>
              <div className="value slds-truncate">
                {this.props.assetType.type}
              </div>
            </div>
            {this.selectedAsset()}
          </div>
          {this.replaceButton()}
        </div>
      </div>
    );
  }
}

FallbackCard.propTypes = {
  assetType: PropTypes.object.isRequired,
  onSelectFallback: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  actions: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(FallbackCard);
